import React from 'react';
import { Grid } from '@mui/material';

interface IHeaderLayoutProps {
  children?: React.ReactNode;
  title: string;
}

const VaultHeaderLayout: React.FC<IHeaderLayoutProps> = (props: IHeaderLayoutProps) => {
  const { children, title } = props;
  return (
    <section className='home-content-body Home-HeaderDown' style={{ minHeight: 0 }} >
      <Grid container>
        <Grid item xs={12}>
          <div className='vault-header-title'>
            <div className='vault-header-contents'>
              <h2>{title}</h2>
            </div>
          </div>
        </Grid>
        <div className='HomeDashboard-container'>
          {children}
        </div>
      </Grid>
    </section>
  );
};

export default VaultHeaderLayout;
